import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../utils/ApiManager';
import Navbar from '../components/Navbar';
import { theme } from '../utils/theme';

const ForgotPassword = () => {
  const { t } = useTranslation('forgotPassword');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setIsSubmitting(true);

    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.error || t('errors.failed'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background-primary">
      <Navbar />
      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md mx-auto bg-[#0C3B2E] text-white rounded-lg shadow-lg overflow-hidden">
          <div className="px-6 py-8">
            <div className="text-center">
              <h2 className="text-3xl font-bold">
                {t('title')}
              </h2>
              <p className="mt-2 text-sm text-white/80">
                {t('subtitle')}
              </p>
            </div>

            {!message ? (
              <form className="mt-8 space-y-6" onSubmit={handleSubmit} autoComplete="off">
                {error && (
                  <div className="bg-red-900/50 border-l-4 border-red-400 p-4 rounded" role="alert">
                    <p className="text-sm text-white">{error}</p>
                  </div>
                )}

                <div className="space-y-4">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium">
                      {t('labels.email')}
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      autoComplete="email"
                      className="mt-1 block w-full px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-[#6D9773] focus:border-transparent"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`${theme.button.base} ${theme.button.cta} w-full ${theme.button.sizes.lg} ${
                      isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                    }`}
                  >
                    {isSubmitting ? t('submitting') : t('buttons.resetPassword')}
                  </button>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-700/30 text-center">
                  <Link to="/login" className="text-sm py-2 px-4 inline-block text-[#6D9773] hover:text-white font-medium">
                    {t('backToLogin')}
                  </Link>
                </div>
              </form>
            ) : (
              <div className="mt-8">
                <div className="bg-green-900/50 border-l-4 border-green-400 p-4 rounded" role="alert">
                  <p className="text-sm text-white">{message}</p>
                </div>
                <div className="mt-6 text-center">
                  <Link to="/login" className={`${theme.button.base} ${theme.button.primary} px-6 py-2`}>
                    {t('backToLogin')}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;